import React, {Component} from 'react';
import {withStyles} from 'material-ui/styles';
import styles from '../style/styles';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import StaffTranslationsTable from './StaffTranslationsTable';
import {
    deleteStaffTranslation,
} from '../thunks';
import {
    fetchSites,
} from '../../sites/thunks';
import ScrollToTop from '../../../components/scroll-top/ScrollToTop';

class StaffTranslationsList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            translationId: null,
            staffId: null
        };
    };

    componentWillMount() {
        this.props.fetchSites();
    };

    componentWillUnmount() {
        toastr.removeByType('error');
    };

    deleteStaffTranslation = (staffId, translationId) => {
        this.props.deleteStaffTranslation(
            this.state.staffId,
            this.state.translationId
        )
        this.setState({
            open: false,
            translationId: null,
            staffId: null
        });
    };

    handleClickOpenDialog = (staffId, translationId) => {
        this.setState({
            open: true,
            translationId: translationId,
            staffId: staffId
        });
    };

    handleRequestCloseDialog = () => {
        this.setState({
            open: false,
            translationId: null,
            staffId: null
        });
    };

    render() {
        return (
            this.props.loading !== true && [
                <StaffTranslationsTable
                    key={0}
                    staffMember={this.props.staffMember}
                    sites={this.props.sites}
                    staffTranslations={this.props.staffTranslations}
                    classes={this.props.classes}
                    handleClickOpen={this.handleClickOpenDialog.bind(this)}
                    handleSubmit={this.deleteStaffTranslation.bind(this)}
                    handleRequestClose={this.handleRequestCloseDialog.bind(this)}
                    open={this.state.open}
                />,
                <ScrollToTop key={1} />
            ]
        )
    }
}

const mapStateToProps = state => ({
    staffMember: state.staff.staffMember,
    staffTranslations: state.staff.staffTranslations,
    sites: state.sites.all,
    loading: state.layout.ajaxCallsInProgress > 0,
});

export default connect(mapStateToProps, {
    fetchSites,
    deleteStaffTranslation,
})(withStyles(styles)(StaffTranslationsList));


// WEBPACK FOOTER //
// ./src/containers/staff/translations/StaffTranslationsIndex.jsx